import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Review it
import '@ruby-labs/ui-core-kit/dist/ui-core-kit.cjs.development.css';
import Index from './containers/index';
import reportWebVitals from './reportWebVitals';
import './translations/i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <Index />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
